<div class="logo-container">
  <a [attr.href]="logoLink">
    <img
      [src]="urlBase + '/assets/sm-logos/logotype-lake.svg'"
      alt="SonderMind Logo Lake Color"
    />
  </a>
</div>
